import { z } from 'zod';
import { ClubHostPublicSchema } from './club-hosts.js';
import { NullablePaywallSlugSchema } from '../lib/paywall-slugs.js';

export const AccessStatus = {
  demo: 'demo',
  owned: 'owned',
  locked: 'locked',
} as const;
export type AccessStatus = (typeof AccessStatus)[keyof typeof AccessStatus];

export const ClubVisibility = {
  draft: 'draft',
  published: 'published',
  hidden: 'hidden',
} as const;
export type ClubVisibility = (typeof ClubVisibility)[keyof typeof ClubVisibility];

export const ClubStatus = {
  live: 'live',
  upcoming: 'upcoming',
  recorded: 'recorded',
} as const;
export type ClubStatus = (typeof ClubStatus)[keyof typeof ClubStatus];
export const ClubStatusSchema = z.enum(['live', 'upcoming', 'recorded']);

export const ClubSummarySchema = z.object({
  id: z.string(),
  paywallSlug: NullablePaywallSlugSchema.optional(),
  title: z.string(),
  status: ClubStatusSchema,
  bookAuthor: z.string().nullable(),
  host: ClubHostPublicSchema,
  secondHost: ClubHostPublicSchema.nullable(),
  author: z.string().nullable(),
  authorSubtitle: z.string().nullable(),
  authorAvatarUrl: z.string().nullable(),
  secondAuthor: z.string().nullable(),
  secondAuthorSubtitle: z.string().nullable(),
  secondAuthorAvatarUrl: z.string().nullable(),
  shortDescription: z.string().nullable(),
  coverUrl: z.string().nullable(),
  visibility: z.enum(['draft', 'published', 'hidden']),
  publishedAt: z.string().nullable(),
  accessStatus: z.enum(['demo', 'owned', 'locked']).optional(),
});

export type ClubSummary = z.infer<typeof ClubSummarySchema>;

export const CreateClubSchema = z.object({
  title: z.string().min(1).max(200),
  status: ClubStatusSchema.default('upcoming'),
  paywallSlug: NullablePaywallSlugSchema.optional(),
  bookAuthor: z.string().max(200).optional(),
  hostFirstName: z.string().max(200).optional(),
  hostLastName: z.string().max(200).optional(),
  hostSubtitle: z.string().max(200).optional(),
  hostAvatarAssetId: z.string().uuid().optional(),
  secondHostFirstName: z.string().max(200).optional(),
  secondHostLastName: z.string().max(200).optional(),
  secondHostSubtitle: z.string().max(200).optional(),
  secondHostAvatarAssetId: z.string().uuid().optional(),
  shortDescription: z.string().max(500).optional(),
  priceAmount: z.number().int().min(0).optional(),
  priceCurrency: z.string().length(3).optional(),
});

export type CreateClubDto = z.infer<typeof CreateClubSchema>;

export const UpdateClubSchema = CreateClubSchema.partial().extend({
  visibility: z.enum(['draft', 'published', 'hidden']).optional(),
});

export type UpdateClubDto = z.infer<typeof UpdateClubSchema>;
